/** @format */

import React from 'react';
import { DotsContainer } from './GalleryCarouselDots.style';
import { CarouselDots } from './CarouselDots/CarouselDots';

type GalleryCarouselDotsProps = {
  currentSlide: number;
  totalPhotos: number;
};

export const GalleryCarouselDots: React.FC<GalleryCarouselDotsProps> = ({ currentSlide, totalPhotos }) => {
  if (totalPhotos < 2) {
    return null;
  }

  return (
    <DotsContainer>
      <CarouselDots total={totalPhotos} current={currentSlide - 1} visible={5} />
    </DotsContainer>
  );
};
